import React from 'react';
import styled from 'styled-components';

const StyledColumn = styled.div<ColumnProps>`
  width: ${({ width }) => `${width}%`};
  padding: 0.75rem 0.375rem;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  &:first-child {
    padding-left: 0.75rem;
  }
  &:last-child {
    padding-right: 0.75rem;
  }
  &.align-right {
    justify-content: flex-start;
    align-items: flex-end;
  }
`;

interface ColumnProps {
  width: number;
}

export const CustomColumn: React.FC<ColumnProps & React.HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  return <StyledColumn {...props} />;
};
